export const getDisplayLabel = (
  companyOutName?: string | null,
  companyInName?: string | null,
) => {
  const out = companyOutName?.trim();
  const inside = companyInName?.trim();

  if (out === inside) {
    return out;
  }

  if (out && inside) {
    return `${out}　--　${inside}`;
  }

  if (out) {
    return out;
  }

  if (inside) {
    return inside;
  }

  return "データなし";
};
